import { Modal, Steps, Button } from "antd";
import { useEffect, useRef, useState } from "react";
import LottoInfoGeneral from "./LottoInfoGeneral/LottoInfoGeneral";
import { showNotificationTopEnd } from "../../../../util/utils";
import LottoImages from "./LottoImages/LottoImages";
import LottoAwards from "./LottoAwars/LottoAwards";
import LottoBonuses from "./LottoBonuses/LottoBonuses";
import {
  callCreateDashboardLotto,
  callUpdateDashboardLotto,
} from "../../../../services/lottoService";

const { Step } = Steps;

export default function LottoModalSteps(props) {
  const { visible, onClose, selectedRecord = null } = props;
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState(0);
  const [formData, setFormData] = useState(selectedRecord);
  const [photos, setPhotos] = useState([]);
  const stepRefs = [useRef(), useRef(), useRef(), useRef()];
  const isEdit = Boolean(selectedRecord);

  useEffect(() => {
    setFormData(selectedRecord);
    if (visible) {
      setCurrent(0);
    } else {
      setFormData(null);
      setPhotos([]);
    }
  }, [selectedRecord, visible]);

  const steps = [
    {
      title: "Rifa",
      description: "Info. General",
      content: (
        <LottoInfoGeneral
          ref={stepRefs[0]}
          visible={visible}
          data={formData}
          isEdit={isEdit}
          onUpdate={(updated) => setFormData({ ...formData, ...updated })}
        />
      ),
    },
    {
      title: "Fotos",
      description: "Fotos Rifa",
      content: (
        <LottoImages
          ref={stepRefs[1]}
          visible={visible}
          data={formData}
          isEdit={isEdit}
          onUpdate={(updated) => setFormData({ ...formData, ...updated })}
          photos={photos}
          onUpdatePhotos={(updater) => setPhotos((prev) => typeof updater === "function" ? updater(prev) : updater)}
        />
      ),
    },
    {
      title: "Premios",
      description: "Premios Rifa",
      content: (
        <LottoAwards
          ref={stepRefs[2]}
          visible={visible}
          data={formData}
          isEdit={isEdit}
          onUpdate={(updated) => setFormData({ ...formData, ...updated })}
        />
      ),
    },
    {
      title: "Bonus",
      description: "Extra Bonus Rifa",
      content: (
        <LottoBonuses
          ref={stepRefs[3]}
          visible={visible}
          data={formData}
          isEdit={isEdit}
          onUpdate={(updated) => setFormData({ ...formData, ...updated })}
        />
      ),
    },
  ];

  const next = async () => {
    const currentRef = stepRefs[current];
    if (currentRef?.current?.validate) {
      try {
        await currentRef.current.validate();
        setCurrent((prev) => prev + 1);
      } catch (err) {
        showNotificationTopEnd("error", "Valida los campos del formulario");
      }
    } else {
      setCurrent((prev) => prev + 1);
    }
  };

  const handleFinishSteps = async () => {
    setLoading(true);

    let response = null;
    if (isEdit) {
      response = await callUpdateDashboardLotto(formData, photos);
    } else {
      response = await callCreateDashboardLotto(formData, photos);
    }
    if (response?.status === 200) {
      //form.resetFields();
      onClose();
      showNotificationTopEnd(
        "success",
        isEdit ? "Sorteo actualizado" : "Sorteo creado"
      );
    } else {
      showNotificationTopEnd("error", "Error al guardar");
    }
    setLoading(false);
  };

  const prev = () => setCurrent((prev) => prev - 1);

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1100}
      centered
      destroyOnHidden
    >
      <Steps current={current} size="large" style={{ marginBottom: 24 }}>
        {steps.map((item, index) => (
          <Step key={index} title={item.title} description={item.description} />
        ))}
      </Steps>

      <div style={{ minHeight: 200 }}>{steps[current].content}</div>

      <div style={{ marginTop: 24, textAlign: "right" }}>
        {current > 0 && (
          <Button onClick={prev} style={{ marginRight: 8 }}>
            Anterior
          </Button>
        )}
        {current < steps.length - 1 && (
          <Button type="primary" onClick={next}>
            Siguiente
          </Button>
        )}
        {current === steps.length - 1 && (
          <Button type="primary" onClick={handleFinishSteps} loading={loading}>
            Finalizar
          </Button>
        )}
      </div>
    </Modal>
  );
}
